/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

(function () {
  const siteNavigation = document.querySelector("#site-navigation");
  const siteBranding = document.querySelector("#header .site-branding");

  // Return early if the navigation don't exist.
  if (!siteNavigation) {
    return;
  }

  const button = document.querySelector(".menu-toggle");

  // Return early if the button don't exist.
  if ("undefined" === typeof button) {
    return;
  }

  const menu = siteNavigation.querySelector("ul");

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener("click", function () {
    siteNavigation.classList.toggle("toggled");
    siteBranding.classList.toggle("toggled");

    if (button.getAttribute("aria-expanded") === "true") {
      button.setAttribute("aria-expanded", "false");
      document.querySelector("body").style.overflow = "visible";
    } else {
      button.setAttribute("aria-expanded", "true");
      document.querySelector("body").style.overflow = "hidden";
    }
  });

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener("click", function (event) {
    let menuItem;
    menu.querySelectorAll("li").forEach((el) => {
      if (el.contains(event.target)) {
        menuItem = true;
      }
    });
    const isClickInside = menuItem || button.contains(event.target); //perhaps also menu: menu.contains(event.target) ||

    if (!isClickInside || menuItem) {
      siteNavigation.classList.remove("toggled");
      button.setAttribute("aria-expanded", "false");
      document.querySelector("body").style.overflow = "visible";
    }
  });
})();

const navContainer = document.querySelector(".wp-block-navigation__responsive-container");
const logo = document.querySelector(".maweda-logo-mobile");

if (navContainer && logo) {
  const observer = new MutationObserver(() => {
    if (navContainer.classList.contains("has-modal-open") && navContainer.classList.contains("is-menu-open")) {
      logo.classList.add("maweda-logo-mobile-opened");
    } else {
      logo.classList.remove("maweda-logo-mobile-opened");
    }
  });

  observer.observe(navContainer, { attributes: true, attributeFilter: ["class"] });
}
